import { useMemo, useState } from "react";
import SearchStockList from "./SearchStockList";
import InventoryForm from "../InventoryForm";
import StepTimeline from "./StepTimeline";
import { useNavigate } from "react-router-dom";
import { customerAttachmentParser } from "../../../utils/stockList.utils";

export default function InventoryStep({
  title,
  editItem,
  existVehicle,
  redirectTo,
  addAccessories
}) {
  const navigate = useNavigate();
  const editFormattedItem = customerAttachmentParser(editItem);
  const attachement = editFormattedItem?.attachment;

  // is exist vehicle ? that means add from already have vehicle information through route state
  const isExistVehicle = !!existVehicle?.id;

  const vehicle = attachement?.car ? attachement?.car : isExistVehicle ? existVehicle : null;

  const [step, setStep] = useState({
    importer: attachement?.importer ? attachement?.importer : null,
    car: vehicle,
    receiver: attachement?.receiver ? attachement?.receiver : null,
    currentStep: editFormattedItem?.id ? 2 : isExistVehicle ? 2 : 1,
    carSearch: attachement?.car?.chassis ?? existVehicle?.fullChassis ?? "",
    addAccessories: attachement?.accessories ?? addAccessories ?? ""
  });

  const onBack = () => {
    if (isExistVehicle || !!editItem?.id) {
      navigate(redirectTo);
    } else {
      setStep((prev) => ({ ...prev, currentStep: 1 }));
    }
  };

  const importer = step?.importer ?? null;
  const car = step?.car ?? null;
  const receiver = step?.receiver ?? null;

  let defaultValues = useMemo(() => {
    return {
      car: {
        stock_list_id: car?.id ?? car?.stock_list_id ?? "",
        sku: car?.sku ?? "",
        name: car?.name ?? "",
        chassis: car?.fullChassis ?? car?.chassis ?? "",
        engine: car?.engine ?? "",
        year: car?.year ?? "",
        color: car?.color ?? "",
        cc: car?.cc ?? "",
        fuel: car?.fuel ?? "",
        tyre_size: car?.tyre_size ?? "",
        mileage: car?.mileage ?? ""
      },
      importer: {
        name: importer?.name ?? "",
        mobile: importer?.mobile ?? "",
        designation: importer?.designation ?? "",
        company: importer?.company ?? "",
        address: importer?.address
      },
      receiver: {
        name: receiver?.name ?? ""
      },
      accessories: step?.addAccessories ?? "",
      inventoryDate: editFormattedItem?.inventoryDate
        ? editFormattedItem.inventoryDate
        : new Date(),
      id: editFormattedItem?.id ? editFormattedItem.id : ""
    };
  }, [car, editFormattedItem, receiver, step, importer]);

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-6 mx-auto">
          <StepTimeline step={step} />
          {step.currentStep === 1 && (
            <SearchStockList step={step} setStep={setStep} onBack={onBack} />
          )}
        </div>

        {step.currentStep === 2 && (
          <InventoryForm
            existVehicle={existVehicle}
            title={title}
            defaultValues={defaultValues}
            onBack={onBack}
            redirectTo={redirectTo}
          />
        )}
      </div>
    </>
  );
}
